export const generateChapterId = chapterId => `ch${chapterId}`;
export const generateSectionId = sectionId => `se${sectionId}`;
export const generateParagraphId = (sectionId, paragraphId) => `${generateSectionId(sectionId)}pa${paragraphId}`;
export const generatePartId = (
  sectionId, paragraphId, partId
) => `${generateParagraphId(sectionId, paragraphId)}stk${partId}`;
